import {State} from "../state";


export async function updateFilter(state: State, foo: string) {
  const newState = Object.assign({}, state);

  return newState;
}

